import { RecordKind } from "~/gql/graphqlBase.generated";
import { normalizeGuid, stripDashes } from "~/helpers/wsId";

export interface LineRefusal {
	code?: null | string;
	message: string;
	recordId?: null | string;
	recordKind?: RecordKind;
}

export interface PostRefusalCopy {
	lineKey: string;
	postKey: string;
	replayKey: string;
}

const OTHER_REFUSAL_COPY: PostRefusalCopy = {
	lineKey: "engage.postFailure.line.other",
	postKey: "engage.postFailure.post.other",
	replayKey: "engage.postFailure.replay.other"
};

const REFUSAL_COPY_BY_CODE: Readonly<Record<string, PostRefusalCopy>> = {
	CYCLE_COUNT_QUANTITY_OVER_CAP: {
		lineKey: "engage.postFailure.line.quantityOverCap",
		postKey: "engage.postFailure.post.quantityOverCap",
		replayKey: "engage.postFailure.replay.quantityOverCap"
	},
	ITEM_COMBINED: {
		lineKey: "engage.postFailure.line.itemCombined",
		postKey: "engage.postFailure.post.itemCombined",
		replayKey: "engage.postFailure.replay.itemCombined"
	}
};

export const describePostRefusal = (refusalCode: null | string): PostRefusalCopy =>
	(refusalCode && REFUSAL_COPY_BY_CODE[refusalCode]) || OTHER_REFUSAL_COPY;

const resolveRefusedLineIds = (refusal: LineRefusal | null, postedItemIds: readonly string[]): string[] => {
	if (!refusal) return [];
	if (refusal.recordKind === RecordKind.Item && refusal.recordId) {
		const recordId = normalizeGuid(refusal.recordId);
		return postedItemIds.filter((itemId) => normalizeGuid(itemId) === recordId);
	}
	// wsapi sets no recordId on these refusals yet, so the refused item's id is only found inside the message.
	const message = stripDashes(refusal.message).toLowerCase();
	const namedFirst = postedItemIds
		.map((itemId) => ({ itemId, position: message.indexOf(normalizeGuid(itemId)) }))
		.filter(({ position }) => position >= 0)
		.sort((a, b) => a.position - b.position)[0];
	return namedFirst ? [namedFirst.itemId] : [];
};

export default resolveRefusedLineIds;
